import React from 'react'
import { toastr } from 'react-redux-toastr'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import OrganizationEditDialog from './OrganizationEditDialog'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import PropTypes from 'prop-types'

export class OrganizationRow extends React.Component {
    handleDelete = () => {
        const { item, onDelete } = this.props
        const toastrConfirmOptions = {
            onOk: () => onDelete(item.remoteId)
        }
        toastr.confirm('Ви впевнені, що хочете видалити організацію?', toastrConfirmOptions)
    }

    render() {
        const { item, classes, openId, onOpenDialog, onCloseDialog, onUpdate, nested } = this.props

        return (
            <TableRow hover key={item.remoteId}>
                <TableCell className={nested ? classes.nestedCell : undefined}>{item.ourId}</TableCell>
                <TableCell>{item.ourName}</TableCell>
                <TableCell>{item.remoteId}</TableCell>
                <TableCell>{item.remoteName}</TableCell>
                {/*<TableCell>*/}
                {/*    {item.active ? (*/}
                {/*        <strong className={classes.active}>АКТИВНА</strong>*/}
                {/*    ) : (*/}
                {/*        <strong className={classes.notActive}>НЕ АКТИВНА</strong>*/}
                {/*    )}*/}
                {/*</TableCell>*/}
                <TableCell padding="none">
                    <OrganizationEditDialog
                        item={item}
                        open={openId === item.remoteId}
                        onOpen={onOpenDialog}
                        onClose={onCloseDialog}
                        onUpdate={onUpdate}
                    />
                </TableCell>
                <TableCell padding="none">
                    <IconButton aria-label="Delete" onClick={this.handleDelete}>
                        <DeleteIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        )
    }
}

OrganizationRow.propTypes = {
    item: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    openId: PropTypes.string,
    onOpenDialog: PropTypes.func.isRequired,
    onCloseDialog: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    nested: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/OrganizationTab/OrganizationTable/OrganizationRow.js